export const twitterBlue = "#1b97f0";
export const borderGray = "#c5d0d8";
export const barelyVisibleGrayBg = "rgba(251, 251, 251, 0.81)";
// export const barelyVisibleGrayBg = "orange";
